import React, { PropsWithChildren } from 'react';
import { ThemeProvider as ThemeProviderLib } from 'styled-components';
import { GlobalTypeScaleStyle } from '@/common/view/typescales';
import { GlobalColorsStyle } from '@/common/view/colors';
import { GlobalSelectStyle } from '@/common/view/form/Select';
import { ToastContainer } from '@/common/view/Toast';
import { TooltipGlobalStyle } from '@/common/view/Tooltip';
import { MultiSelectGlobalStyle } from '@/common/view/MultiSelect';
import { theme } from './defaultTheme';

export const ThemeProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <ThemeProviderLib theme={theme}>
      {children}
      <GlobalTypeScaleStyle />
      <GlobalColorsStyle />
      <GlobalSelectStyle />
      <TooltipGlobalStyle />
      <MultiSelectGlobalStyle />
      <ToastContainer />
    </ThemeProviderLib>
  );
};
